import React from 'react';
import PropTypes from 'prop-types';

const SettingIcon = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect id="Bound" width="25" height="25" fill="none" opacity="0.2" />
      <path id="Combined-Shape" d="M4.563,7H9.771a1.562,1.562,0,1,1,0,3.125H4.563A1.562,1.562,0,1,1,4.563,7Zm9.375,8.333h5.208a1.563,1.563,0,0,1,0,3.125H13.937a1.563,1.563,0,0,1,0-3.125Z" transform="translate(0.125 0.292)" fill={color} fillRule="evenodd" opacity="0.3" />
      <path id="Combined-Shape-2" d="M17.583,11.25a3.125,3.125,0,1,1,3.125-3.125A3.125,3.125,0,0,1,17.583,11.25ZM6.125,19.583A3.125,3.125,0,1,1,9.25,16.458,3.125,3.125,0,0,1,6.125,19.583Z" transform="translate(0.125 0.208)" fill={color} fillRule="evenodd" />
    </svg>
  );
}

SettingIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

SettingIcon.defaultProps = {
  color: '#FFFFFF',
  width: 24,
  height: 24,
};

export default SettingIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/SettingIcon.jsx